export default function createPromiseQueue() {
  let isProcessing = false;
  const queue: Array<() => Promise<unknown>> = [];

  const processQueue = async () => {
    if (isProcessing || queue.length === 0) {
      return;
    }

    isProcessing = true;

    while (queue.length > 0) {
      const callback = queue.shift();
      if (callback) {
        await callback();
      }
    }

    isProcessing = false;
  };

  return <T>(callback: () => Promise<T>): Promise<T> => {
    return new Promise((resolve, reject) => {
      queue.push(async () => {
        try {
          const result = await callback();
          resolve(result);
        } catch (error) {
          reject(error);
        }
      });
      processQueue();
    });
  };
}
